import { connect } from 'react-redux'
import { fetchExpenseList, resetExpenseSearch } from 'store/Expense'
import {
  clearNewMessage,
  clearPopTartHistory,
  clearRequestType,
  postMessage,
  fetchMemberCommsMessages,
  setAshSessionId,
  setSelectedSpecialty,
} from 'store/MemberCommunication'

import { RequestForm as BaseRequestForm } from './RequestForm'

const mapStateToProps = ({ Expense, Member, MemberCommunication }) => ({
  ashSessionId: MemberCommunication.ashSessionId?.entity,
  fields: MemberCommunication.requestType?.entity?.fields,
  members: Object.values(Member.members?.entities || {}),
  newRequestId: MemberCommunication.newRequest?.entity?.id,
  newRequestBusy: MemberCommunication.newRequest?.busy,
  newRequestError: MemberCommunication.newRequest?.error,
  requestType: MemberCommunication.requestType?.entity,
  searchResults: Expense.searchResults?.entries,
  searchResultsBusy: Expense.searchResults?.busy,
  searchResultsEnd: Expense.searchResults?.endOfResults,
  selectedSpecialty: MemberCommunication.selectedSpecialty?.entity,
})

const mapDispatchToProps = {
  clearNewMessage,
  clearPopTartHistory,
  clearRequestType,
  postMessage,
  fetchExpenseList,
  fetchMemberCommsMessages,
  resetExpenseSearch,
  setAshSessionId,
  setSelectedSpecialty,
}

export const RequestForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseRequestForm)
